const EquivalencyTypes = {
    HOME: 'HOME',
    AUTOMOTIVE: 'AUTOMOTIVE',
};

export default EquivalencyTypes;


/** WEBPACK FOOTER **
 ** ./src/redux/modules/equivalencies/EquivalencyTypes.js
 **/